import { render, staticRenderFns } from "./DiEmailAdressEditor.vue?vue&type=template&id=9cc52d76&scoped=true&"
import script from "./DiEmailAdressEditor.vue?vue&type=script&lang=js&"
export * from "./DiEmailAdressEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc52d76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
